<template>
<LayoutSearchFieldVertical
  v-if="facet"
  display-variant="list"
>
      <div class="facet-buttons">
        <button
          class="fb-button"
          v-for="(count, tag) in counts"
          :class="{
            'is-0': count === 0,
            'is-exclude': exclude,
            'is-selected': isSelected('+' + tag),
          }"
          @click="select(tag)"
          :key="tag"
        >
          <UiTagSpan class="fb-label" :id="tag" :notag="true">
            <template v-slot="{ tag }">
              {{ tagDisplay(tag) }}
            </template>
          </UiTagSpan>
          <span class="fb-count" :title="num(count)">{{ nums(count) }}</span>
        </button>
        <div class="no-facet" v-if="isEmpty(counts)">
          {{ lss('該当なし', 'No Hit') }}
        </div>
      </div>

      <template #nav v-if="showShowAll">
        <BaseToggleSwitch class="is-red" v-model="showAll">{{
          lss('全て表示', 'Show all')
        }}</BaseToggleSwitch>
      </template>
      <template #options>
        <BaseToggleSwitch class="is-red" v-model="exclude">{{
          lss('除外', 'Exclude')
        }}</BaseToggleSwitch>
      </template>
</LayoutSearchFieldVertical>
</template>

<script lang="ts" setup>
import { useSearchFieldBase } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { ls, lss, num, nums } = useI18n()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { facet, excludeDisplay } = useSearchFieldBase(props)

const MAX_FACET = 10

const exclude: Ref<boolean> = ref(false)

const count = tag => {
  if (!facet.value) return undefined
  return facet.value.counts[tag] || 0
}

const select = (tag: string) => {
  if (exclude.value) tag = '-' + tag
  else tag = '+' + tag
  if (isSelected(tag)) {
    props.ss.removeFilter(props.field.key, [tag])
  } else {
    props.ss.addFilter(props.field.key, [tag])
  }
}

const isSelected = (tag: string) => {
  return props.ss.state.filter[props.field.key]?.includes(tag)
}

const tagDisplay = (tag: Tag) => {
  if (tag) {
    let v = ls(tag.label)
    return excludeDisplay(v, exclude.value, count(tag.id))
  }
  return ''
}

const showShowAll = computed(() => {
  return facet.value && Object.keys(facet.value.counts).length > MAX_FACET
})

const showAll: Ref<boolean> = ref(false)

const counts = computed(() => {
  if (!facet.value) return {}
  let keys = Object.keys(facet.value.counts).sort(
    (a, b) => facet.value.counts[b] - facet.value.counts[a],
  )
  if (!showAll.value) keys = keys.slice(0, Math.min(MAX_FACET, keys.length))
  let obj = {}
  keys.forEach(key => {
    obj[key] = facet.value.counts[key]
  })
  return obj
})
</script>
